export default __webpack_public_path__ + "static/media/frame-cards.f702bbfd.svg";